import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=1a33719a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a33719a')) {
      api.createRecord('1a33719a', component.options)
    } else {
      api.reload('1a33719a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=1a33719a&", function () {
      api.rerender('1a33719a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20CPbdo3KnWGu/JS/comp/ErrorMessage.vue"
export default component.exports